import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import moment from "moment";
import HasPermission from '../helper/user.js';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default class EditCash extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cash: {},
            hasPermissionCancel:false,
            staff_payment_request_details: []
        }
        this.saveData = this.saveData.bind(this);
        this.setData = this.setData.bind(this);
        this.getData = this.getData.bind(this);
        this.handleInptChange = this.handleInptChange.bind(this);
        this.cancelCash = this.cancelCash.bind(this);
        this.handleRedirect = this.handleRedirect.bind(this);
    }
    
    /**
     * Init data
     */
    componentWillMount() {
        HasPermission('/api/cashes/delete').then(permission => {this.setState({hasPermissionCancel: permission})});
        if (this.props.match.params.hasOwnProperty('id')) {
            //Edit cash
            const cashId = this.props.match.params.id;
            axios.get('/api/cashes/' + cashId).then(response => {
                this.setData(response.data);
            }).catch(() => {
                this.props.history.push('/_404');
            })
            
            //Get staff payment request detail
            axios.get('/api/cashes/staff-payment-request-detail/' + cashId).then(response => {
                this.setState({
                    staff_payment_request_details: response.data
                })
            });
        }
        
    }
    
    /**
     * Set data of cash
     * data: Object Cash
     */
    setData(data) {
        this.setState({
            cash: data
        })
    }
    
    /**
     * Get data of cash
     */
    getData() {
        return this.state.cash;
    }
    
    /**
     * Listen change input
     * event: Object input
     */
    handleInptChange(event) {
        let cashCopy = Object.assign({}, this.state.cash);
        cashCopy[event.target.name] = event.target.value;
        this.setState({cash: cashCopy});
    }
    
    fireRedirect(e) {
        e.preventDefault()
        this.props.onHandleRedirect(e.currentTarget.getAttribute('href'));
    }
    
    /**
     * Call function save data from element parent
     */
    saveData() {
        let cash = this.getData();
        //to top
        window.scrollTo(0, 0)
        axios.post('/api/cashes/edit/' + cash.id, cash).then(response => {
            if (response.data.hasOwnProperty('success') && response.data.success) {
                toast.success(response.data.message)
            } else {
                Object.keys(response.data.errors).map((key, i) => {
                        if($.isArray(response.data.errors[key])){
                            response.data.errors[key].map((child, i) => {
                                toast.error(child)
                            })
                        } else {
                            toast.error(response.data.errors[key])
                        }
                    }
                )
            }
        }).catch(error => {
            Object.keys(error.response.data.errors).map((key, i) => {
                    if($.isArray(error.response.data.errors[key])){
                        error.response.data.errors[key].map((child, i) => {
                            toast.error(child)
                        })
                    } else {
                        toast.error(error.response.data.errors[key])
                    }
                }
            )
        })
    }
    
    /**
     * Handle show text with status
     */
    processStatus(status) {
        switch(status) {
            case 0: 
                return "申請のみ";
            case 100: 
                return "送金中";
            case 1:
                return "受け取り待ち";
            case 2:
                return "受け取り済";
            case 92:
                return "補正完了";
            case 93:
                return "承認待ち";
            case 94:
                return "支払取消";
            case 95:
                return "受取期限切れ";
            case 96:
                return "キャンセル済";
            case 97:
                return "7bankAPI失敗（リクエスト）";
            case 98:
                return "7bankAPI失敗（レスポンス）";
            case 99:
                return "審査NG";
            default:
                return "未承認";
        }
    }
    processStatusRemittanceResult(status) {
        switch(status) {
            case 100: 
                return "送金中";
            case 1:
                return "送金済み";
            case 2:
                return "送金済み";
            case 95:
                return "送金済み";
            case 96:
                return "キャンセル済";
            case 97:
                return "失敗";
            case 99:
                return "審査NG";
            default:
                return "";
        }
    }
    processStatusReceiptResult(status) {
        switch(status) {
            case 2:
                return "受取済み";
            case 95:
                return "受取期限切れ";
            case 98:
                return "失敗";
            default:
                return "";
        }
    }
    
    processNotification(notification) {
        switch(notification) {
            case '10':
                return "自社通知";
            case '20':
                return "代行（Eメール）";
            case '21':
                return "代行（SMS）";
            default:
                return "";
        }
    }
    
    /**
     * Cancel staff payment request
     */
    cancelCash(){
        let cash = this.getData();
        if (window.confirm('この現金申請をキャンセルしてよろしいですか？')) {
            //to top
            window.scrollTo(0, 0)
            axios.get('/api/cashes/delete/' + cash.id, cash).then(response => {
                if (response.data.success) {
                    toast.success(response.data.message)
                    this.setData(response.data.cash);
                } else if (response.data.error) {
                    toast.error(response.data.message)
                    this.setData(response.data.cash);
                } else {
                    Object.keys(response.data.errors).map((key, i) => {
                            if($.isArray(response.data.errors[key])){
                                response.data.errors[key].map((child, i) => {
                                    toast.error(child)
                                })
                            } else {
                                toast.error(response.data.errors[key])
                            }
                        }
                    )
                }
            }).catch(error => {
                Object.keys(error.response.data.errors).map((key, i) => {
                        if($.isArray(error.response.data.errors[key])){
                            error.response.data.errors[key].map((child, i) => {
                                toast.error(child)
                            })
                        } else {
                            toast.error(error.response.data.errors[key])
                        }
                    }
                )
            })
        }
    }
    
    /**
     * Handle redirect
     */
    handleRedirect(e) {
        e.preventDefault()
        this.props.history.push(e.currentTarget.getAttribute('href'));
    }
    
    render() {
        return (
            <React.Fragment>
                <div className="row">
                    <div className="col-sm-12">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb mb-0">
                                <li className="breadcrumb-item"><a onClick={this.handleRedirect} href="/home">ダッシュボード</a></li>
                                <li className="breadcrumb-item"><a onClick={this.handleRedirect} href="/cashes">現金申請</a></li>
                                <li className="breadcrumb-item active" aria-current="page">現金申請編集</li>
                            </ol>
                        </nav>
                    </div>
		</div>
		<main id="main">
                    <div className="row justify-content-md-center">
                        <div className="col-sm-6">
                            <div className="card mb-3">
                                <div className="card-header p-4 border-bottom-0"><h4 className="mb-0">現金申請編集</h4></div>
                                <div className="card-body">
                                    <div className="form-group row">
                                        <label className="col-sm-4 col-form-label text-right">ID</label>
                                        <div className="col-sm-8">
                                            <label className="col-value text-left">{this.state.cash.id}</label>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-sm-4 col-form-label text-right">ワーカーID</label>
                                        <div className="col-sm-8">
                                            <label className="col-value text-left">{this.state.cash.staff_id}</label>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-sm-4 col-form-label text-right">申請者：漢字(カナ)</label>
                                        <div className="col-sm-8">
                                            <label className="col-value text-left">{this.state.cash.first_last_name}</label>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-sm-4 col-form-label text-right">メールアドレス</label>
                                        <div className="col-sm-8">
                                            <label className="col-value text-left">{this.state.cash.staffEmail}</label>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-sm-4 col-form-label text-right">携帯電話番号</label>
                                        <div className="col-sm-8">
                                            <label className="col-value text-left">{this.state.cash.staffTel}</label>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-sm-4 col-form-label text-right">通知手段</label>
                                        <div className="col-sm-8">
                                            <label className="col-value text-left">{this.state.cash.msg_way_cd ? this.processNotification(this.state.cash.msg_way_cd) : ''}</label>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-sm-4 col-form-label text-right">取引内容</label>
                                        <div className="col-sm-8">
                                            <label className="col-value text-left">シェアジョブ 現金申請</label>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-sm-4 col-form-label text-right">申請額</label>
                                        <div className="col-sm-8">
                                            <label className="col-value text-left">{this.state.cash.request_point ? '¥' + parseInt(this.state.cash.request_point).toLocaleString() : ''}</label>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-sm-4 col-form-label text-right">手数料</label>
                                        <div className="col-sm-8">
                                            <label className="col-value text-left">{this.state.cash.request_fee ? '¥'+parseInt(this.state.cash.request_fee).toLocaleString() : ''}</label>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-sm-4 col-form-label text-right">振込額</label>
                                        <div className="col-sm-8">
                                            <label className="col-value text-left">{this.state.cash.rmtc ? '¥'+parseInt(this.state.cash.rmtc).toLocaleString() : ''}</label>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-sm-4 col-form-label text-right">ステータス</label>
                                        <div className="col-sm-8">
                                            <label className="col-value text-left">{this.state.cash.status != null ? this.processStatus(this.state.cash.status) : '未承認'}</label>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-sm-4 col-form-label text-right">送金結果</label>
                                        <div className="col-sm-8">
                                            <label className="col-value text-left">{this.state.cash.status != null ? this.processStatusRemittanceResult(this.state.cash.status) : ''}</label>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-sm-4 col-form-label text-right">受取結果</label>
                                        <div className="col-sm-8">
                                            <label className="col-value text-left">{this.state.cash.status != null ? this.processStatusReceiptResult(this.state.cash.status) : ''}</label>
                                        </div>
                                    </div>
                                    { this.state.cash.error_code ? 
                                    <div className="form-group row">
                                        <label className="col-sm-4 col-form-label text-right">エラーコード</label>
                                        <div className="col-sm-8">
                                            <label className="col-value text-left">{this.state.cash.error_code}</label>
                                        </div>
                                    </div>
                                    : ''
                                    }
                                    { this.state.cash.error_message ? 
                                    <div className="form-group row">
                                        <label className="col-sm-4 col-form-label text-right">エラーメッセージ</label>
                                        <div className="col-sm-8">
                                            <label className="col-value text-left">{this.state.cash.error_message}</label>
                                        </div>
                                    </div>
                                    : '' }
                                    <div className="form-group row">
                                        <label className="col-sm-4 col-form-label text-right">申請日</label>
                                        <div className="col-sm-8">
                                            <label className="col-value text-left">{this.state.cash.created_at ? moment(this.state.cash.created_at).format("YYYY年MM月DD日 HH:mm") : ''}</label>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-sm-4 col-form-label text-right">振込日</label>
                                        <div className="col-sm-8">
                                            <label className="col-value text-left">{this.state.cash.request_send_day ? moment(this.state.cash.request_send_day).format("YYYY年MM月DD日 HH:mm") : ''}</label>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-sm-4 col-form-label text-right">受取日</label>
                                        <div className="col-sm-8">
                                            <label className="col-value text-left">{this.state.cash.result_get_day ? moment(this.state.cash.result_get_day).format("YYYY年MM月DD日 HH:mm") : ''}</label>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-sm-4 col-form-label text-right">送金処理通番</label>
                                        <div className="col-sm-8">
                                            <label className="col-value text-left">{this.state.cash.rem_proc_seqno}</label>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-sm-4 col-form-label text-right">送金依頼管理番号</label>
                                        <div className="col-sm-8">
                                            <label className="col-value text-left">{this.state.cash.rem_req_mng_no}</label>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-sm-4 col-form-label text-right">送金依頼明細番号</label>
                                        <div className="col-sm-8">
                                            <label className="col-value text-left">{this.state.cash.staff_payment_req_id}</label>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-sm-4 col-form-label text-right">お客様番号</label>
                                        <div className="col-sm-8">
                                            <label className="col-value text-left">{this.state.cash.staffId}</label>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-sm-4 col-form-label text-right">1,000円未満支払方法</label>
                                        <div className="col-sm-8">
                                            <label className="col-value text-left">{this.state.cash.result_1000yen_payment_method}</label>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-sm-4 col-form-label text-right">取消更新日時</label>
                                        <div className="col-sm-8">
                                            <label className="col-value text-left">{this.state.cash.result_cancel_day ? moment(this.state.cash.result_cancel_day).format("YYYY年MM月DD日 HH:mm") : ''}</label>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-sm-4 col-form-label text-right">期限切れ更新日時</label>
                                        <div className="col-sm-8">
                                            <label className="col-value text-left">{this.state.cash.result_expire_day ? moment(this.state.cash.result_expire_day).format("YYYY年MM月DD日 HH:mm") : ''}</label>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-sm-4 col-form-label text-right">メモ</label>
                                        <div className="col-sm-8">
                                            <textarea onChange={this.handleInptChange} name="memo" value={this.state.cash.memo ? this.state.cash.memo : ""}  className="form-control" rows="8"></textarea>
                                        </div>
                                    </div>
                                </div>
                            <div className="card-footer text-center">
                                <button onClick={this.saveData} className="btn btn-primary btn-radius btn-lg clearfix"><span className="size-inherit">保存する</span></button>
                                {((this.state.cash.status == 0 || this.state.cash.status == 100) && this.state.hasPermissionCancel) ? <button onClick={this.cancelCash} className="btn btn-danger btn-radius btn-lg"><span className="size-inherit">申請をキャンセル</span></button> : ''}
                            </div>
                        </div>
                        <div className="card mt-3">
                            <div className="card-header p-4 border-bottom-0"><h4 className="mb-0">現金申請詳細一覧</h4></div>
                            <div className="card-body">
                                <div className="list-group">
                                {this.state.staff_payment_request_details.length == 0 ? 'データがありません。' :
                                    this.state.staff_payment_request_details.map((dataRow, i) => {
                                        return <a key={i} onClick={this.handleRedirect} href={"/jobapplys/edit/" + dataRow.job_apply_id} className="list-group-item list-group-item-action flex-column align-items-start">
                                                <div className="d-flex w-100 justify-content-between">
                                                <h5 className="mb-1"><span>{dataRow.request_price ? '¥' + parseInt(dataRow.request_price).toLocaleString() : '-'}</span></h5>
                                                <span>{dataRow.created_at ? moment(dataRow.created_at).format("YYYY/MM/DD") : '-'}</span>
                                                </div>
                                                <div className="d-flex w-100 justify-content-between">
                                                    <p className="mb-1">依頼ID:{dataRow.job_id ? dataRow.job_id : '-'}　応募ID:{dataRow.job_apply_id ? dataRow.job_apply_id : '-'}</p>
                                                </div>
                                            </a>
                                    })
                                }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                </main>
                <ToastContainer />
            </React.Fragment>
        )
    }
}
